module.exports = "pegasus/assets/blocks/column-16-theme4.png";